/* admin_localities */
export const GET_ADMIN_COMPANIES_REQUEST =
  'resources/admin/localities/GET_ADMIN_COMPANIES_REQUEST'
export const GET_ADMIN_COMPANIES_SUCCESS =
  'resources/admin/localities/GET_ADMIN_COMPANIES_SUCCESS'
export const GET_ADMIN_COMPANIES_ERROR =
  'resources/admin/localities/GET_ADMIN_COMPANIES_ERROR'
